/* 比赛数据推送更新 event/market/odds */

const eventDefaultKey = {
  topic: 'topic',
  allScores: 'allScores',
  betStatus: 'betStatus',
  eventGameScores: 'scoreOfSection',
  eventMatchStatus: 'statusDescription',
  eventTotalPlayedTime: 'totalPlayedTime',
  eventStoppageTime: 'stoppageTime',
  eventPointScore: 'scoreInCurrentSection',
  eventRemainingTimeInPeriod: 'sectionRemainTime',
  eventScore: 'scoreOfWholeMatch',
  eventStatus: 'status',
  fixtureAwayTeamName: 'awayTeam',
  fixtureHomeTeamName: 'homeTeam',
  fixtureSportCategoryName: 'category',
  fixtureSportName: 'sport',
  fixtureStartTime: 'startTime',
  fixtureTournamentName: 'tournament',
  productStatus: 'productStatus',
  // sport的eventSize
  bmLcooCount: 'bmLcooCount', // 目前可投 market 数量
  liveChannel: 'hasLive', // 是否有直播
  soccerCornerScore: 'soccerCornerScore',
  soccerBookingsScore: 'soccerBookingsScore',
  server: 'server' // 发球方
}

// events 推送消息需要更新的字段
// 这里必须所有字段都更新，因为在列表页面可能新增一场比赛
const eventUpdateDefaultKey = {
  topic: 1,
  allScores: 1,
  betStatus: 1,
  scoreOfSection: 1,
  statusDescription: 1,
  totalPlayedTime: 1,
  stoppageTime: 1,
  scoreInCurrentSection: 1,
  sectionRemainTime: 1,
  scoreOfWholeMatch: 1,
  status: 1,
  awayTeam: 1,
  homeTeam: 1,
  category: 1,
  sport: 1,
  startTime: 1,
  tournament: 1,
  productStatus: 1,
  bmLcooCount: 1,
  hasLive: 0,
  soccerCornerScore: 1,
  soccerBookingsScore: 1,
  server: 1
}

const eventNumberKey = {
  status: 1,
  betStatus: 1,
  startTime: 1,
  hasLive: 1,
  bmLcooCount: 1
}

/*
  对应的原始数据的key，没有对应key使用原始key
 */
const marketDefaultKey = ['topic', 'product', 'status', 'description', 'group', 'isFavourite', 'guidance', 'pushTime', 'presentationType', 'priority']

// marketStatus 推送消息需要更新的字段
const marketUpdateDefaultKey = {
  product: 1,
  status: 1,
  description: 1,
  group: 1,
  isFavourite: 1,
  pushTime: 1,
  presentationType: 1,
  priority: 1
}

/*
  odds default config
  对应的原始数据的key, 没有对应的key使用原始key
 */
const oddsDefaultKey = [
  'topic',
  'product',
  'status',
  'description',
  'group',
  'isFavourite',
  'guidance',
  'pushTime',
  'presentationType',
  ['id', 'description', 'odds', 'isActive', 'isWinning', 'refundFactor', 'probability'],
  'priority'
]

// outcome  推送消息需要更新的字段
const oddsUpdateDefaultKey = {
  id: 1,
  description: 1,
  odds: 1,
  isActive: 1,
  probability: 1
}

const defToNumSet = {
  isActive: 1,
  product: 1,
  status: 1,
  isFavourite: 1,
  presentationType: 1,
  priority: 1
}

// 推送数据可能为空的字段，不进行合并
/**
 * 只合并数据不为空的 key-value
 * @param {Object} target  目标对象
 * @param {String} key     字段名
 * @param {String} key     字段值
 */
// 需要进行判断的 key 值
const mayEmptyKeys = ['description', 'group', 'guidance']
function mergeWith(target, key, value) {
  // 数值直接合并；推送数据可能为空的字段，不进行合并
  if ((typeof value === 'number' && !isNaN(value)) || !mayEmptyKeys.includes(key) || value) {
    Object.assign(target, { [key]: value })
  }
  if (key === 'priority' && isNaN(value)) {
    delete target.priority
  }
}

function parsePushData(pushData, type) {
  if (!pushData) return

  // market status的推送消息处理
  if (type === 'market') {
    return parseMarket(pushData)
  } else if (type === 'event') {
    // event数据转换成了一个对象，通过对象处理
    return parseEvent(pushData)
  }

  // odds推送消息处理，数组的部分
  return parseOdds(pushData)
}

function parseMarket(pushData) {
  const ret = {}
  if (!pushData.length) {
    return
  }
  // 只更新需要更新的字段，即在updateKey中的字段
  for (let i = 0, keyLen = pushData.length; i < keyLen; i++) {
    const key = marketDefaultKey[i]
    let value = pushData[i]
    if (marketUpdateDefaultKey[key] && value !== null) {
      if (defToNumSet[key]) {
        value = Number(value)
      }
      mergeWith(ret, key, value)
    }
  }
  return ret
}

function parseOdds(pushData) {
  const ret = {}
  const oddsIndex = 9
  const outcomeKeys = oddsDefaultKey[oddsIndex]
  let outcomes = []
  try {
    const tmp = pushData[oddsIndex]
    if (typeof tmp === 'string') {
      outcomes = JSON.parse(tmp)
    } else if (tmp.length) {
      outcomes = tmp
    }
  } catch (e) {
    console.log(e)
  }

  if (!Array.isArray(outcomes)) {
    // 上线时删除console
    console.log(`push outcome error ${pushData}`)
    return
  }

  for (const item of outcomes) {
    const values = item ? item.split('#') : []
    // 比odds需要更新字段的量少，数据不完整，不更新
    if (values.length >= outcomeKeys.length) {
      const id = values[0]
      ret[id] = {}
      // 只更新需要更新的字段，即在updateKey中的字段
      for (let i = 1, keyLen = values.length; i < keyLen; i++) {
        const key = outcomeKeys[i]
        let value = values[i]
        if (oddsUpdateDefaultKey[key] && value) {
          if (defToNumSet[key]) {
            value = Number(value)
          }
          mergeWith(ret[id], key, value)
        }
      }
    }
  }
  return ret
}

function parseEvent(pushData) {
  const result = {}
  if (!pushData) {
    return result
  }
  for (const key in pushData) {
    const k = eventDefaultKey[key] || key
    if (eventUpdateDefaultKey[k]) {
      const value = pushData[key]
      result[k] = eventNumberKey[k] ? Number(value) : value
    }
  }
  return result
}

export default parsePushData
